<template>
  <div class="priceList" v-if="priceData">
    <table>
      <tr class="under_separator">
        <td>商品・配送費（税込）</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.subTotalPrice + priceData.subTotalTax)}}</td>
      </tr>
      <tr>
        <td>{{itemName}}</td>
        <td>{{formatPrice(priceData.itemPrice)}} × {{dcProductCount}}</td>
        <td>{{formatPrice(priceData.itemPrice * dcProductCount)}}</td>
      </tr>
      <tr class="indent_1">
        <td colspan="3">{{productSize}}</td>
      </tr>
      <tr class="indent_1" v-if="isFillerOn">
        <td colspan="3">{{fillerSize}}</td>
      </tr>
      <tr class="indent_1" v-for="(op,index) in optionList" :key="'option-' + index">
        <td colspan="3">{{op}}</td>
      </tr>
      <tr v-if="isCalcDelivery">
        <td>配送料</td>
        <td>{{formatPrice(priceData.delivaryPrice * dcProductCount)}} × 1</td>
        <td class="price">{{formatPrice(priceData.delivaryPrice * dcProductCount)}}</td>
      </tr>
      <tr>
        <td>消費税</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.subTotalTax)}}</td>
      </tr>
    </table>
    <table class="tbl_space">
      <tr class="under_separator" v-if="priceData.constructTotalPrice">
        <td>組立設置他サービス小計（税込）</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.constructTotalPrice + priceData.constructTotalTax)}}</td>
      </tr>
      <tr v-if="priceData.constructPrice">
        <td>組立技術料</td>
        <td>{{formatPrice(priceData.constructPrice * dcProductCount)}} × 1</td>
        <td class="price">{{formatPrice(priceData.constructPrice * dcProductCount)}}</td>
      </tr>
      <tr v-if="priceData.carryInPrice">
        <td>受け取り搬入サービス費</td>
        <td>{{formatPrice(priceData.carryInPrice * dcProductCount)}} × 1</td>
        <td class="price">{{formatPrice(priceData.carryInPrice * dcProductCount)}}</td>
      </tr>
      <tr v-if="priceData.executionVarExpensesPrice">
        <td>諸経費</td>
        <td>{{formatPrice(priceData.executionVarExpensesPrice)}} × 1</td>
        <td class="price">{{formatPrice(priceData.executionVarExpensesPrice)}}</td>
      </tr>
      <tr v-if="priceData.constructTotalTax">
        <td>消費税</td>
        <td></td>
        <td class="price">{{formatPrice(priceData.constructTotalTax)}}</td>
      </tr>
    </table>
    <div class="totalPrice">
      <div>合計金額（税込）</div>
      <!-- <div>{{formatPrice(priceData.totalPrice + priceData.totalTax)}}</div> -->
      <div>{{formatPrice(priceData.totalTax)}}</div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    itemName: {
      type: String,
      default: ''
    },
    priceData: {
      type: Object
    },
    targetPlan: {
      type: Object,
      default: undefined
    },
    isCalcDelivery: {
      type: Boolean,
      default: false
    },
    dcProductCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    productSize: function () {
      if (!this.targetPlan) return ''
      let sizeStr = []
      if (this.targetPlan.dcWidth) sizeStr.push('W:' + this.targetPlan.dcWidth)
      if (this.targetPlan.dcHeight) sizeStr.push('H:' + this.targetPlan.dcHeight)
      if (this.targetPlan.dcDepth) sizeStr.push('D:' + this.targetPlan.dcDepth)
      if (this.targetPlan.dcWidth2) sizeStr.push('W2:' + this.targetPlan.dcWidth2)
      // if (this.targetPlan.dcHeight2) sizeStr.push('H2:' + this.targetPlan.dcHeight2)
      if (this.targetPlan.dcDepth2) sizeStr.push('D2:' + this.targetPlan.dcDepth2)
      return sizeStr.join(', ')
    },
    fillerSize: function () {
      if (!this.targetPlan) return ''
      let fillerStr = []
      if (this.targetPlan.dcBSize) fillerStr.push('左フィラー:' + this.targetPlan.dcBSize)
      if (this.targetPlan.dcCSize) fillerStr.push('右フィラー:' + this.targetPlan.dcCSize)
      if (this.targetPlan.dcDSize) fillerStr.push('上フィラー:' + this.targetPlan.dcDSize)
      return fillerStr.join(', ')
    },
    optionList: function () {
      if (!this.targetPlan) return []
      let opList = []
      if (this.targetPlan.dcShelfCount > 0) opList.push('追加部材 可動棚:' + this.targetPlan.dcShelfCount + '枚/列')
      if (this.targetPlan.dcFillerCount > 0) opList.push('追加部材 フィラー:' + this.targetPlan.dcFillerCount + '本')
      return opList
    },
    isFillerOn: function () {
      if (!this.targetPlan) return false
      if (this.targetPlan.dcBType !== 0 || this.targetPlan.dcCType !== 0 || this.targetPlan.dcDType !== 0) return true
      return false
    }
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    itemType: function (type) {
      if (type === 'PART_DOOR_BOARD') {
        return '扉:'
      } else if (type === 'UNIT_SKELTON') {
        return '箱:'
      } else if (type === 'UNIT_MOBILE_SHELF') {
        return '棚板：'
      } else if (type === 'UNIT_FILLER') {
        return 'フィラー：'
      }
      return ''
    },
    sizeName: function (w, h, d) {
      if (!w || !h || !d) return ''
      return w + '×' + h + '×' + d + '(mm)'
    },
    profitPrice: function (price) {
      if (!price || !this.priceData) return
      return Math.floor(price * (this.priceData.profitPercent / 100))
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/PriceList.vue